import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SettingPermissionsService } from '@core/services';
import { BISettingsPermissionsScreenCodes } from '@shared/common/permissionsList.enum';
import { redirectToAccessDenied } from '@shared/utilities';
import { catchError, map, of } from 'rxjs';

type TPermission = keyof typeof BISettingsPermissionsScreenCodes;

export const settingsGuard = (
  permissions: TPermission | TPermission[],
): CanActivateFn => {
  return () => {
    const router = inject(Router);
    const settingPermissionsService = inject(SettingPermissionsService);
    return settingPermissionsService.settingScreensPermissions$.pipe(
      map(settings => {
        const currentSettingPermission = settings.find(
          x =>
            permissions &&
            x.screenCode ===
              BISettingsPermissionsScreenCodes[permissions as TPermission],
        );

        if (!currentSettingPermission?.canView) {
          redirectToAccessDenied(router);
        }
        return currentSettingPermission?.canView ?? false;
      }),
      catchError(() => {
        redirectToAccessDenied(router);
        return of(false);
      }),
    );
  };
};
